var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfused2Bg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 136,
    viewBox: "0 0 300 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 2L66 32",
    stroke: "#45413C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66 2L36 32",
    stroke: "#45413C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 69.0476C0 77.6308 11.5822 84.5595 25.8531 84.5595C40.1241 84.5595 51.7063 77.6308 51.7063 69.0476C51.7063 60.4643 40.1241 53.5357 25.8531 53.5357C11.5822 53.5357 0 60.4643 0 69.0476Z",
    fill: "#FFAA54"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M235 2L265 32",
    stroke: "#45413C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M265 2L235 32",
    stroke: "#45413C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M299.897 69.0476C299.897 77.6308 288.315 84.5595 274.044 84.5595C259.773 84.5595 248.19 77.6308 248.19 69.0476C248.19 60.4643 259.773 53.5357 274.044 53.5357C288.315 53.5357 299.897 60.4643 299.897 69.0476Z",
    fill: "#FFAA54"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86 93.7857C86 104.338 92.7729 114.457 104.829 121.918C116.885 129.38 133.236 133.571 150.286 133.571C167.335 133.571 183.687 129.38 195.743 121.918C207.798 114.457 214.571 104.338 214.571 93.7857C214.571 83.2339 207.798 73.1142 195.743 65.653C183.687 58.1917 167.335 54 150.286 54C133.236 54 116.885 58.1917 104.829 65.653C92.7729 73.1142 86 83.2339 86 93.7857Z",
    fill: "#FFB0CA",
    stroke: "#45413C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103 112.5C103 117.407 107.899 122.112 116.62 125.581C125.34 129.051 137.167 131 149.5 131C161.833 131 173.66 129.051 182.38 125.581C191.101 122.112 196 117.407 196 112.5C196 107.593 191.101 102.888 182.38 99.4185C173.66 95.9491 161.833 94 149.5 94C137.167 94 125.34 95.9491 116.62 99.4185C107.899 102.888 103 107.593 103 112.5Z",
    fill: "#FF866E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfused2Bg);
export default __webpack_public_path__ + "static/media/confused-2-bg.523233596c44350d7319a50f3010dc5d.svg";
export { ForwardRef as ReactComponent };